import { render, staticRenderFns } from "./SpoiledSearch.vue?vue&type=template&id=2366e9e9&scoped=true&"
import script from "./SpoiledSearch.vue?vue&type=script&lang=js&"
export * from "./SpoiledSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2366e9e9",
  null
  
)

export default component.exports